"use client";
//#region packages/@mantine/core/src/utils/Floating/get-floating-position/get-floating-position.ts
function getFloatingPosition(dir, position) {
	if (dir === "rtl" && (position.includes("right") || position.includes("left"))) {
		const [side, placement] = position.split("-");
		const flippedPosition = side === "right" ? "left" : "right";
		return placement === void 0 ? flippedPosition : `${flippedPosition}-${placement}`;
	}
	return position;
}
//#endregion
export { getFloatingPosition };

//# sourceMappingURL=get-floating-position.mjs.map